module.exports = __webpack_public_path__ + "static/media/newOP.644a12a6.svg";